export default "__VITE_ASSET__dad8174c__"